import React from "react";
import { withRouter } from 'react-router-dom';

class ScrollToTop extends React.Component {
  componentDidUpdate(prevProps) {
    if ((this.props.location.pathname !== prevProps.location.pathname)) {
      const isPathnamePhone = (this.props.location.pathname !== '/phone') && (prevProps.location.pathname !== '/phone');
      const isPathnameLocation = (this.props.location.pathname !== '/locations') && (prevProps.location.pathname !== '/locations');

      if (isPathnamePhone && isPathnameLocation) {
        setTimeout(() => {
          window.scrollTo(0, 0);
        });
      }
    }
  }

  render() {
    return this.props.children;
  }
}


export default withRouter(ScrollToTop);


// WEBPACK FOOTER //
// ./src/components/scroll-top/ScrollToTop.js